import { Box, FormControl, FormControlLabel, FormHelperText, Switch, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { TakePaymentFormData } from '~/modules/payment/components/TakePayment/helpers/TakePaymentSchema';
import useGetSalesTax from '~/modules/payment/hooks/useGetSalesTax';

export default function PaymentTaxableField() {
  const {
    control,
    formState: { errors },
  } = useFormContext<TakePaymentFormData>();
  const { salesTax } = useGetSalesTax();

  return (
    <Controller
      control={control}
      name="taxable"
      render={({ field: { value, ...field } }) => (
        <FormControl fullWidth>
          <FormControlLabel
            {...field}
            checked={value}
            control={<Switch />}
            label={
              <Box sx={{ mr: 12 }}>
                <Typography variant="h3">Taxable</Typography>
                <FormHelperText>
                  Toggle on to apply your tax rate from business settings{salesTax ? ` of ${salesTax}%` : ' (N/A)'}
                </FormHelperText>
              </Box>
            }
            labelPlacement="start"
            sx={{ ml: 0, justifyContent: 'space-between' }}
          />
          {!!errors.taxable && <FormHelperText error>{errors.taxable.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
}
